const giftTagCheckbox = document.querySelector('#gift-tag')

const giftTagRecipient = document.querySelector('#recipient-name')
const giftTagRecipientWrapper = document.querySelector('.recipient-name-wrapper')

const giftTagSender = document.querySelector('#sender-name')
const giftTagSenderWrapper = document.querySelector('.sender-name-wrapper')

giftTagCheckbox.addEventListener('change', function() {
    if (this.checked) {
        giftTagRecipient.setAttribute('required', '')
        giftTagRecipientWrapper.classList.remove('hidden')

        giftTagSender.setAttribute('required', '')
        giftTagSenderWrapper.classList.remove('hidden')
    } else {
        giftTagRecipient.removeAttribute('required', '')
        giftTagRecipientWrapper.classList.add('hidden')

        giftTagSender.removeAttribute('required', '')
        giftTagSenderWrapper.classList.add('hidden')
    }
  });